import { SelectOptions } from 'components/core/Select/AppSelect';
import { capitalize } from '@alluradirect/react';
import dayjs from 'dayjs';

export const months = {
  january: 1,
  february: 2,
  march: 3,
  april: 4,
  may: 5,
  june: 6,
  july: 7,
  august: 8,
  september: 9,
  october: 10,
  november: 11,
  december: 12,
};

export const generateMonthLabel = (month: number): string => {
  return capitalize(Object.keys(months)[month - 1].toString());
};

/** Generates all month options unless a fromMonth is provided */
export const generateMonthOptions = (fromMonth?: number): SelectOptions => {
  const availableMonths = Object.values(months);
  const filteredMonths = fromMonth ? availableMonths.filter(month => month >= fromMonth) : availableMonths;

  return filteredMonths.map(month => {
    return {
      value: month,
      label: generateMonthLabel(month),
    };
  });
};

export const generateDaysInMonth = (month: number): number => {
  // dayjs months are 0-indexed
  return dayjs()
    .set('month', month - 1)
    .daysInMonth();
};

export const generateDayOptions = (month: number): SelectOptions => {
  const daysInMonth = generateDaysInMonth(month);

  const dayOptions = [];
  for (let i = 1; i <= daysInMonth; i++) {
    dayOptions.push({
      id: i,
      value: i,
      label: i.toString(),
    });
  }

  return dayOptions;
};
